module.exports = __webpack_public_path__ + "assets/img/white_holly-8e0ca73d.jpg";